import { render, staticRenderFns } from "./addChange.vue?vue&type=template&id=60b987d9&scoped=true&"
import script from "./addChange.vue?vue&type=script&lang=js&"
export * from "./addChange.vue?vue&type=script&lang=js&"
import style0 from "./addChange.vue?vue&type=style&index=0&id=60b987d9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b987d9",
  null
  
)

export default component.exports